import React, { useEffect } from 'react';
import Highcharts from 'highcharts';

const CustomPieChartLoader = ({ percentage }) => {
    // 80 steps in 5 seconds, 1.25% of each step in 62.5 milliseconds
    const totalPercent = percentage * 1.25;
    const blankPart = 100 - totalPercent;

    let pieChart;
    useEffect(() => {
        pieChart = new Highcharts.Chart({
            chart: {
                renderTo: 'pie-four',
                type: 'pie',
            },
            credits: {
                enabled: false,
            },
            title: {
                text: '',
            },
            tooltip: {
                enabled: false,
                animation: false,
                shadow: false,
            },
            plotOptions: {
                pie: {
                    dataLabels: {
                        enabled: false,
                    },
                },
            },
            series: [
                {
                    type: 'pie',
                    name: 'Value',
                    innerSize: '60%',
                    size: 20,
                    animation: false,
                    data: [
                        {
                            name: '',
                            y: totalPercent,
                            color: '#d04a02',
                        },
                        {
                            name: '',
                            y: blankPart,
                            color: 'white',
                        },
                    ],
                },
            ],
        });
        return () => {
            pieChart.destroy();
        };
    }, [pieChart, totalPercent]);

    return (
        <div id="pie-four" style={{ height: 30, width: 30, paddingTop: '0.2rem' }} />
    );
};

export default CustomPieChartLoader;
